// extracted by mini-css-extract-plugin
export default {"container":"Photo-module--container--c967a","cover":"Photo-module--cover--28ba8","loading":"Photo-module--loading--73eea","fadeIn":"Photo-module--fadeIn--904f3"};